/**
 * Normalize journal list from Django / DRF-style responses.
 * Supports: bare array, { journals }, paginated { results }, nested { data }.
 */
export function journalsFromApiResponse(payload) {
  if (payload == null) return [];
  if (Array.isArray(payload)) return payload;
  if (typeof payload !== "object") return [];
  if (Array.isArray(payload.journals)) return payload.journals;
  if (Array.isArray(payload.results)) return payload.results;
  if (Array.isArray(payload.data)) return payload.data;
  return [];
}
